if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		connectedCallback() {
			const changeItemsInCart = document.querySelector("[data-delivery-method-change-items-in-cart]");
			if(changeItemsInCart) 
				document.addEventListener("delivery-method-changed", this.onDeliveryMethodChanged.bind(this));
		}

		onDeliveryMethodChanged(e) {
			const deliveryMethod = e.detail.newDeliveryMethod;
			const changedFromCart = e.detail.changedFromCart;
			const cartItemsToChange = document.querySelectorAll("[data-change-on-delivery-method]");

			if(!deliveryMethod) return;
		
			if(deliveryMethod == 'free') {
				cartItemsToChange.forEach((item) => {
					if(item.dataset.currentVariantId === item.dataset.baleVariantId) {
						this.updateCartQty(item, 0);
					}
				});
			}
			else {
				cartItemsToChange.forEach((item) => {
					if(item.dataset.currentVariantId !== item.dataset.baleVariantId) {
						this.updateCartQty(item, 0);
					}
				});
			}
		  }

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){
			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const eventGlobal = new Event('cart-updated-global');
					document.dispatchEvent(eventGlobal);
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.qtyMin = this.querySelector('.qty-minus');
			this.qtyMax = this.querySelector('.qty-plus');
			this.qty = this.querySelector('.qty-selector');
			this.qtyMin.addEventListener('click', this.changeCartInput.bind(this));
			this.qtyMax.addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				if(parseInt(this.qty.value) <= this.qty.getAttribute('min') && !this.qtyMin.classList.contains("data-value-changed")) {
					
				}
				else {
					document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
				}
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

		this.inputs = this.querySelectorAll("[data-input-note]");
		this.noteField = this.querySelector("[data-note-field]");

		this.inputs.forEach((input) => {
			input.addEventListener("change", this.updateMainInput.bind(this));
		});

		this._initWithVatNote();
      }

	  _getVatNote() {
		const vatEl = document.querySelector('[data-vat-note]');
		return vatEl ? (vatEl.getAttribute('data-vat-note') || '') : '';
	  }

	  _appendVatNote(note) {
		const vatNote = this._getVatNote();
		return vatNote ? note + (note.length ? "\n\n\n" : "") + vatNote : note;
	  }

	  _initWithVatNote() {
		if (!this.noteField) return;
		const userNoteField = this.querySelector("#CartDrawer-Other");
		const vatNote = this._getVatNote();
		const userNote = vatNote
			? userNoteField.value.replace("\n\n\n" + vatNote, "").replace(vatNote, "").trim()
			: userNoteField.value.trim();
		userNoteField.value = userNote;
		this.updateCartNote(this._appendVatNote(userNote));

		const checkoutBtn = document.getElementById('CheckOut');
		if (checkoutBtn) {
			checkoutBtn.addEventListener('click', (e) => {
				const pending = this._pendingNote;
				if (pending) {
					e.preventDefault();
					e.stopImmediatePropagation();
					pending.then(() => checkoutBtn.form.submit());
				}
			}, true);
		}
	  }

	  updateMainInput(e) {
		let note = ""
		this.inputs.forEach((input) => {
			const value = input == e.target ? e.target.value : (input.checked ? input.value : null);
			if (value !== null) {
				note += (note.length ? ", " : "") + value;
			}
		})

		this.updateCartNote(this._appendVatNote(note));
	  }


      updateCartNote(note) {
		this.noteField.innerHTML = note;

		const body = JSON.stringify({ note: note });
		this._pendingNote = fetch(`${KROWN.settings.routes.cart_update_url}`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/javascript",
			},
			body,
		}).finally(() => {
			this._pendingNote = null;
		});
      }
    }
  );
}